module.exports = __webpack_public_path__ + "static/media/arol.7fe7774a.jpg";